import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import 'moment/locale/nl';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { preserveAgrSessionSnapshot, setupRuntimeConfig } from './app/runtime-config';

if (environment.PRODUCTION) {
  enableProdMode();
}
preserveAgrSessionSnapshot();
setupRuntimeConfig.then(() => {
  bootstrapApplication(AppComponent, appConfig).catch((err) => {
    console.error(err);
  });
});
